export default __webpack_public_path__ + "static/media/icon_match.9c256ad7.svg";